define('AwaLabs.OnlyGiftCertificate', [
    'OnlyGiftCertificate.Header.MiniCartItemCell.View'
], function OnlyGiftCertificate(
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent('Layout');
            if (layout) {
                layout.addToViewContextDefinition('ProductViews.Price.View', 'isGistCardWithVariableAmount', 'boolean', function fnLoyaltyPrice(context) {
                    return !!(context.model &&
                        context.model.item &&
                        context.model.item.itemtype === 'GiftCert' &&
                        context.model.item.custitem_awa_is_variable_amount);
                });
            }
        }
    };
});
